import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PostPardotService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }

  /**
   * @description llamada al servicio Pardot
   * @params body
   */
  postPostPardot(body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      // 'X-API-Key': '6d6f1b59781c6bd0b6fe85febab65712' // TST
      // 'X-API-Key': 'edf07afce33711edbe494bf01b96ca5c' // PRO
      'X-API-Key': environment.pardotAPIKey
    });
    return this.http.post(
      // '/candidatos', // Proxy
      // 'https://sltest.santalucia.es/iris-campanyas/v1/candidatos', // TEST
      // 'https://apis.santalucia.es/iris-campanyas/v1/candidatos',  // PRO
      environment.productMediador + 'iris-campanyas/v1/candidatos',  // PRO
      body,
      { headers }
    );
  }
}
